/** Shared by pagination and keyboard navigation; document groups always come last. */
export const SEARCH_RESULT_GROUP_ORDER = [
    'CUSTOMER',
    'PRODUCT',
    'SUPPLIER',
    'CONTACT',
    'ADDRESS',
    'CATEGORY',
    'BATCH',
    'ACTIVITY',
    'CALL',
    'DOCUMENT',
    'LEGACY_DOCUMENT',
    'PURCHASE_ORDER',
    'GOODS_RECEIPT',
    'DMS_DOCUMENT',
];
//# sourceMappingURL=search.js.map